<template>
    <Layout_UserFollowerView :header-text="$t('users.title-followings')">
        <Users_Feed v-if="module" :module="module" :no-results-message="$t('users.no-followings')"/>
    </Layout_UserFollowerView>
</template>

<script>
import StoreFactory_UserFollowers from "@/store/factories/StoreFactory_UserFollowers";
import Users_Feed from "@/ui/components/users/Users_Feed";
import Layout_UserFollowerView from "@/ui/layouts/Layout_UserFollowerView";

export default {
    name: "UserView_Followings",
    components: { Users_Feed, Layout_UserFollowerView },
    props: {
        userSlug: String,
    },
    data() {
        return { module: null }
    },
    mounted() {
        this.module = StoreFactory_UserFollowers.createForUserFollowings(this.userSlug);
    },
    beforeDestroy() {
        this.module.unregisterModule();
        this.module = null;
    }

}
</script>
